module.exports = __webpack_public_path__ + "df5731bb29ec0dbbc2cf0c6e552e54ed.svg";